<template>
  <b-card>
    <div
      class="d-flex flex-column align-items-center"
    >
      <b-card-title>
        <h3 class="text-center">
          Trip Number
        </h3>
      </b-card-title>
      <h4
        class="font-weight-bold trip_number_color"
      >
        {{ tripNumber }}
      </h4>

    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle,
} from 'bootstrap-vue'
import { inject } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BCardTitle,
  },
  setup() {
    const trip = inject('trip')
    const tripNumber = trip.value.external_id

    return {
      tripNumber,
    }
  },
}
</script>

<style scoped>
.trip_number_color{
    color: green;
}

</style>
